import React, { Component, ReactNode } from 'react';
import { NotificationType, PushNotification } from '../../../../domain/notification/NotificationDomains';
import NotificationCheckerRequestComponent from './NotificationCheckerRequestComponent';
import NotificationClient from '../../../../client/notification/NotificationClient';
import GatewayContainer from '../../../../config/GatewayContainer';
import GatewayNames from '../../../../constant/GatewayNames';
import EmptyComponent from '../../empty-components/EmptyComponent';
import ComponentName from '../../../../constant/ComponentName';
import { CheckerRequest } from '../../../../domain/maker-checker/MakerCheckerDomains';
import _ from 'lodash';

class NotificationBodyComponent extends Component<Props> {
  private observer: IntersectionObserver | undefined;

  private readonly notificationClient: NotificationClient = GatewayContainer.getInstance().get(GatewayNames.NOTIFICATION_CLIENT);

  public render(): ReactNode {
    const { notifications } = this.props;
    if (notifications == undefined || notifications.length == 0) {
      return (
        <div className={'flex w-full h-full px-5 py-5'}>
          <EmptyComponent type={ComponentName.NOTIFICATIONS} createDisabled />
        </div>
      );
    }
    return (
      <div className='px-5 py-5 gap-y-5 flex flex-col'>
        {notifications.map((n, i) => {
          return (
            <span key={n.id} className={`observable-notification ${i < notifications.length - 1 ? 'border-b' : ''}`} id={n.id}>
              {this.getItem(n)}
            </span>
          );
        })}
      </div>
    );
  }

  private getItem = (notification: PushNotification) => {
    const { checkerRequests } = this.props;
    switch (notification.type) {
      case NotificationType.MAKER_CHECKER_REQUEST:
        const request = checkerRequests.find((c) => c.id == notification.metadata?.id);
        return <NotificationCheckerRequestComponent key={notification.id} notification={notification} request={request} />;
      default:
        return null;
    }
  };

  public componentDidMount() {
    this.observe();
  }

  public componentDidUpdate(prevProps: Props) {
    if (!_.isEqual(prevProps.notifications, this.props.notifications)) {
      this.observer?.disconnect();
      this.observe();
    }
  }

  public componentWillUnmount() {
    this.observer?.disconnect();
  }

  private observe = () => {
    this.observer = new IntersectionObserver(this.handleIntersection);
    const element = document.querySelectorAll('.observable-notification');
    element.forEach((e) => this.observer?.observe(e));
  };

  private handleIntersection = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        this.read(id);
      }
    });
  };

  private read = async (id: string) => {
    const { notifications } = this.props;
    const notification = notifications.find((n) => n.id === id);
    if (notification == undefined || notification.read) return;
    await this.notificationClient.read(notification.id);
  };
}

interface Props {
  notifications: PushNotification[];
  checkerRequests: CheckerRequest[];
}

export default NotificationBodyComponent;
